import script from "./detail.vue?vue&type=script&setup=true&lang=ts"
export * from "./detail.vue?vue&type=script&setup=true&lang=ts"

import "./detail.vue?vue&type=style&index=0&id=886dd602&lang=scss&scoped=true"

import exportComponent from "D:\\桌面\\报价系统\\quotesystem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-886dd602"]])

export default __exports__